// extracted by mini-css-extract-plugin
export default {"page":"NewOrder_page__ekP5l","p":"NewOrder_p__exO9M"};